
import { useDailyVerseStore } from "@/store/dailyVerseStore";

const getMonthAndYear = (dateText) => {
    const date = new Date(dateText);
    const month = date.getMonth();
    const year = date.getFullYear();
    return { month, year };
};
export async function reloadDailyVerses(date) {
    setTimeout(async () => {
        await useDailyVerseStore().fetchDailyVerseByMonth(getMonthAndYear(date));
    }, 500);
}
